import styled from "styled-components";


const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
`
const Titulo = styled.h3`
    margin: 0 0 5px 3px;
    font-size: 14px;
    color: #555;
`
const InputContainer = styled.div`
    width: 100%;
    min-height: 41px;
    height: ${(props) => props.textarea ? "150px" : "auto"};
    text-align: ${(props) => props.textarea ? "justify" : "left"};
    display: flex;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
    padding: 10px 13px 10px 10px;
    box-sizing: border-box;
    background-color: #f9f9f9;
    cursor: default;
    p {
        margin: 0;
        font-size: 14px;
        color: #333;
    }
`

const InputView = ({ label, value, textarea=false }) => {

    return(
        <Container>
            <Titulo>{ label }</Titulo>
            <InputContainer textarea={textarea}>
                <p>{ value }</p>
            </InputContainer>
        </Container>
    )

}

export default InputView;